const snHeaderClass = "header_sn";
const snHeaderInactiveClass = "header__inactive_sn";
const snMobileHeaderClass = "header__mobile_sn";
const snHeaderLogoClass = "header__logo header__logo_sn";
const snHeaderLogoHamburgerClass = "header__logo header__logo_hamburger";
const snHeaderHamburgerMenuCloseClass = "header__hamburger-menu-close-btn_sn";
const snHeaderHamburgerMenuClass =
  "header__hamburger-menu-btn header__hamburger-menu-btn_sn";
const snHeaderMenuClass = "header__menu_sn";
const snHeaderMenuMobileClass = "header__menu-mobile_sn";
const snHeaderMenuButtonClass = "header__button_sn";
const snHeaderMenuLoggedInClass = "header__button-loggedin_active_sn";
const snHeaderMenuLoggedOutClass = "header__button-loggedin_sn";
const snHeaderUserButtonClass = "header__user-button_sn";
const snHeaderLogoutButtonInactiveClass = "header__logout-button_sn";
const snHeaderLogoutButtonActiveClass = "header__logout-button_active_sn";

export {
  snHeaderClass,
  snHeaderInactiveClass,
  snMobileHeaderClass,
  snHeaderLogoClass,
  snHeaderLogoHamburgerClass,
  snHeaderHamburgerMenuCloseClass,
  snHeaderHamburgerMenuClass,
  snHeaderMenuClass,
  snHeaderMenuMobileClass,
  snHeaderMenuButtonClass,
  snHeaderMenuLoggedInClass,
  snHeaderMenuLoggedOutClass,
  snHeaderUserButtonClass,
  snHeaderLogoutButtonInactiveClass,
  snHeaderLogoutButtonActiveClass,
};
